import {contains, filter, findIndex, findWhere, isArray, map} from 'underscore'
import * as mutationTypes from './mutation-types'
import {getStatusDetails, STATUS_READY, STATUS_SIGNED_OUT} from '@windsor-telecom/customer-portal-framework/src/store/static/agent-statuses'

const namespaced = true

const initialState = () => ({
    agents: [],
    loading: true,
    statusList: []
})

const state = initialState()

/**
 * @param {string} statusType
 * @returns {boolean}
 */
function isBusyStatus (statusType) {
    return !contains([STATUS_READY, STATUS_SIGNED_OUT], statusType)
}

const getters = {
    agents: (state, getters) => {
        const agentsFormatted = map(state.agents, agent => {
            const status = getters.statusByUuid(agent.status.uuid)
            const statusDetails = getStatusDetails(status.statusType)

            return {
                ...agent,
                status: {
                    ...agent.status,
                    ...status,
                    ...statusDetails,
                    startTime: new Date(agent.status.startTime)
                }
            }
        })

        return agentsFormatted.sort((a, b) => {
            const aStatusType = a.status.statusType
            const bStatusType = b.status.statusType

            return isBusyStatus(aStatusType) && !isBusyStatus(bStatusType)
                ? -1
                : 0
        })
    },
    agentsFiltered: (state, getters) => filter(getters.agents, agent => agent.signedIn),
    agentsLoading: state => state.loading,
    statusList: state => state.statusList,
    statusByUuid: state => uuid => findWhere(state.statusList, {uuid}) || {}
}

const actions = {
    resetAgents: ({commit}) => commit(mutationTypes.RESET_AGENTS)
}

const mutations = {
    [mutationTypes.RESET_AGENTS]: state => Object.assign(state, initialState()),
    [mutationTypes.SET_AGENTS]: (state, data) => {
        state.loading = false
        state.agents = data
    },
    [mutationTypes.SET_STATUS_LIST]: (state, data) => state.statusList = data,
    [mutationTypes.UPDATE_AGENTS]: (state, data) => {
        if (!isArray(data)) {
            return
        }

        state.agents = map(state.agents, agent => {
            const index = findIndex(data, {uuid: agent.uuid})
            return index !== -1
                ? {...agent, ...data[index]}
                : agent
        })
    },
    [mutationTypes.UPDATE_AGENT_SIGNED_IN]: (state, data) => {
        const {uuid, value} = data
        const index = findIndex(state.agents, {uuid})
        if (index !== -1) {
            state.agents.splice(index, 1, {
                ...state.agents[index],
                signedIn: value
            })
        }
    }
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters
}
